import { NgModule } from '@angular/core';
import { NgxCountdownComponent } from './ngx-countdown.component';

@NgModule({
  declarations: [NgxCountdownComponent],
  exports: [NgxCountdownComponent]
})
export class NgxCountdownModule { }
